import { render } from "./PJP.vue?vue&type=template&id=15b7bc64"
import script from "./PJP.vue?vue&type=script&lang=js"
export * from "./PJP.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\msimi\\Downloads\\KIM\\pvmi-coaching-web-report\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__